import { render, staticRenderFns } from "./scopus.vue?vue&type=template&id=711f698e&"
import script from "./scopus.vue?vue&type=script&lang=js&"
export * from "./scopus.vue?vue&type=script&lang=js&"
import style0 from "./scopus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports